import React from 'react';
import { Link } from 'react-router-dom';
import { mockData } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-primary text-gray-100 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute inset-0 bg-grid-white/[0.02] bg-[size:60px_60px]" />
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-accent/10 rounded-full blur-3xl" />
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-secondary/10 rounded-full blur-3xl" />
      
      <div className="container mx-auto px-4 lg:px-8 relative">
        {/* Main Footer Content */}
        <div className="pt-20 pb-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-[1.2fr_1fr_1fr_0.8fr_1.4fr] gap-6 lg:gap-8">
          {/* Company Info */}
          <div>
            <img src="/assets/img/brand/logo-light.png" alt="Global Trademark Federation" className="h-12 mb-4" />
            <p className="text-gray-300 mb-4 leading-relaxed">
              Protecting your brand legacy with expert trademark registration services across the United States.
            </p>
          </div>
          
          {/* Services */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Our Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services/trademark-registration" className="text-gray-300 hover:text-secondary transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2 group-hover:bg-secondary transition-colors"></span>
                  Trademark Registration
                </Link>
              </li>
              <li>
                <Link to="/services/copyright-registration" className="text-gray-300 hover:text-secondary transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2 group-hover:bg-secondary transition-colors"></span>
                  Copyright Registration
                </Link>
              </li>
              <li>
                <Link to="/services/company-formation" className="text-gray-300 hover:text-secondary transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2 group-hover:bg-secondary transition-colors"></span>
                  Company Formation
                </Link>
              </li>
              <li>
                <Link to="/services/trademark-search" className="text-gray-300 hover:text-secondary transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2 group-hover:bg-secondary transition-colors"></span>
                  Trademark Search
                </Link>
              </li>
              <li>
                <Link to="/services/amazon-brand-registry" className="text-gray-300 hover:text-secondary transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2 group-hover:bg-secondary transition-colors"></span>
                  Amazon Brand Registry
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Other Services */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Other Services</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/services/wipo-registration" className="text-gray-300 hover:text-secondary transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2 group-hover:bg-secondary transition-colors"></span>
                  WIPO Registration
                </Link>
              </li>
              <li>
                <Link to="/services/statement-of-use" className="text-gray-300 hover:text-secondary transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2 group-hover:bg-secondary transition-colors"></span>
                  Statement of Use
                </Link>
              </li>
              <li>
                <Link to="/services/trademark-monitoring" className="text-gray-300 hover:text-secondary transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2 group-hover:bg-secondary transition-colors"></span>
                  Trademark Monitoring
                </Link>
              </li>
              <li>
                <Link to="/services/trademark-office-actions" className="text-gray-300 hover:text-secondary transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2 group-hover:bg-secondary transition-colors"></span>
                  Office Actions
                </Link>
              </li>
              <li>
                <Link to="/services/trademark-ownership-transfer" className="text-gray-300 hover:text-secondary transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2 group-hover:bg-secondary transition-colors"></span>
                  Ownership Transfer
                </Link>
              </li>
              <li>
                <Link to="/services/ttab-petition" className="text-gray-300 hover:text-secondary transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2 group-hover:bg-secondary transition-colors"></span>
                  TTAB Petition
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Company */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Company</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-secondary transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2 group-hover:bg-secondary transition-colors"></span>
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-secondary transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2 group-hover:bg-secondary transition-colors"></span>
                  Contact Us
                </Link>
              </li>
              <li>
                <Link to="/" className="text-gray-300 hover:text-secondary transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2 group-hover:bg-secondary transition-colors"></span>
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/" className="text-gray-300 hover:text-secondary transition-colors flex items-center group">
                  <span className="w-1.5 h-1.5 rounded-full bg-accent mr-2 group-hover:bg-secondary transition-colors"></span>
                  FAQ
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Contact Info */}
          <div>
            <h4 className="text-white font-bold text-lg mb-4">Get In Touch</h4>
            <ul className="space-y-3">
              <li className="flex items-start text-gray-300">
                <svg className="w-5 h-5 mr-2 mt-0.5 text-secondary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
                <span>{mockData.contact.email}</span>
              </li>
              <li className="flex items-start text-gray-300">
                <svg className="w-5 h-5 mr-2 mt-0.5 text-secondary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                </svg>
                <span>{mockData.contact.phone}</span>
              </li>
              <li className="flex items-start text-gray-300">
                <svg className="w-5 h-5 mr-2 mt-0.5 text-secondary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
                </svg>
                <div>
                  <span className="text-secondary text-xs font-semibold uppercase tracking-wide">Head Office</span>
                  <p>{mockData.contact.headOffice}</p>
                </div>
              </li>
              <li className="flex items-start text-gray-300">
                <svg className="w-5 h-5 mr-2 mt-0.5 text-secondary flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
                </svg>
                <div>
                  <span className="text-secondary text-xs font-semibold uppercase tracking-wide">Corporate Building</span>
                  <p>{mockData.contact.corporateBuilding}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-white/10 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-gray-300">
              © 2026 <span className="text-secondary font-semibold">Global Trademark Federation</span>. All rights reserved.
            </div>
            <div className="flex items-center space-x-6 text-sm">
              <Link to="/privacy-policy" className="text-gray-300 hover:text-secondary transition-colors relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:transition-all after:bg-secondary">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="text-gray-300 hover:text-secondary transition-colors relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 hover:after:w-full after:transition-all after:bg-secondary">
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
